import type { ResearchSummary } from '@/api/types';

import { isPending } from '@/ui/ResearchStatusPill';

export interface RowFlags {
  striped: boolean;
  viewing: boolean;
  refinementShown: boolean;
}

export function historyRowClass({ striped, viewing, refinementShown }: RowFlags): string | undefined {
  return [striped && 'is-striped', viewing && 'is-expanded', refinementShown && 'has-refinement'].filter(Boolean).join(' ') || undefined;
}

const notYetOr = (run: ResearchSummary, fallback: string) => (isPending(run.status) ? 'Not yet' : fallback);

/** What the Model cell shows when the run's model is no longer configured, or none was recorded. */
export function modelFallback(run: ResearchSummary): { text: string; className: string; title: string | undefined } {
  if (run.model_key) return { text: run.model_key, className: 'mono hint', title: 'No longer configured on AI Models' };
  return { text: notYetOr(run, 'Not recorded'), className: 'hint', title: undefined };
}

export function durationFallback(run: ResearchSummary): string {
  return isPending(run.status) ? 'Not finished' : 'Not recorded';
}

export function promptNotYet(run: ResearchSummary): boolean {
  return !run.prompt_version && isPending(run.status);
}
